import {countBy, includes, keys, pick, pickBy, get} from 'lodash';
import {
  ACCEPTED,
  APPLIED,
  ENROLLED,
  PLANNING_TO_APPLY,
  PLANNING_TO_ENROLL,
} from '../college-application-status/utils';
import Student, {isUpperClassman} from 'src/models/student';

export const StudentYear = {
  FRESHMAN: 'freshman',
  SOPHOMORE: 'sophomore',
  JUNIOR: 'junior',
  SENIOR: 'senior',
};

export const getEarnings = (collegeEarnings, admissionLikelihood) => {
  const earnings = get(collegeEarnings, 'earnings', []);
  return earnings.map((earning) => ({
    ...earning,
    admissionLikelihoodScoreCategory: admissionLikelihood[earning._id] || null,
  }));
};

export const filterAdmissionLikelihoodByAppStatus = (
  collegeApplicationStatuses,
  admissionLikelihood
) => {
  const applyingStatuses = [PLANNING_TO_APPLY, APPLIED, ACCEPTED, PLANNING_TO_ENROLL, ENROLLED];
  const planningToApplyIDs = keys(
    pickBy(collegeApplicationStatuses, ({status}) => includes(applyingStatuses, status))
  );
  return pick(admissionLikelihood, planningToApplyIDs);
};

export const selectApplicationManagementProps = (props) => {
  const {
    admissionLikelihood,
    collegeEarnings,
    courses,
    collegeApplicationStatuses,
    filterByAppStatus = false,
  } = props;

  const student = new Student(props.student, courses);
  const earnings = getEarnings(collegeEarnings, admissionLikelihood);
  const filteredAdmissionLikelihood = filterByAppStatus
    ? filterAdmissionLikelihoodByAppStatus(collegeApplicationStatuses, admissionLikelihood)
    : admissionLikelihood;

  const admissionLikelihoodTierCounts = countBy(filteredAdmissionLikelihood);
  const totalCredits = student.getCreditCount();
  const isBalancedListInfoAvailable = isUpperClassman(student);
  const gradeLevel = student.getGradeLevelFromYear(student.hsGraduationYear);
  const juniorOrSenior =
    student.isHighSchoolStudent() && [StudentYear.JUNIOR, StudentYear.SENIOR].includes(gradeLevel);

  return {
    earnings,
    admissionLikelihoodTierCounts,
    isBalancedListInfoAvailable,
    totalCredits,
    juniorOrSenior,
  };
};
